"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogMessages = exports.ProgressMessages = exports.ProgressTitles = void 0;
const localizeUtils_1 = require("../common/localizeUtils");
class ProgressTitles {
}
exports.ProgressTitles = ProgressTitles;
ProgressTitles.create = (0, localizeUtils_1.getLocalizedString)("core.progress.create");
class ProgressMessages {
}
exports.ProgressMessages = ProgressMessages;
ProgressMessages.generateTemplate = (0, localizeUtils_1.getLocalizedString)("core.progress.createFromTemplate");
ProgressMessages.generateSample = (sampleName) => (0, localizeUtils_1.getLocalizedString)("core.progress.createFromSample", sampleName);
ProgressMessages.configureAzureStorageEnableStaticWebsite = (0, localizeUtils_1.getLocalizedString)("core.progress.configureAzureStorage");
ProgressMessages.runCommand = (command, directory) => (0, localizeUtils_1.getLocalizedString)("core.progress.runCommand", command, directory);
ProgressMessages.deployToAzure = (location, dist) => (0, localizeUtils_1.getLocalizedString)("core.progress.deployToAzure", location, dist);
class LogMessages {
}
exports.LogMessages = LogMessages;
LogMessages.getTemplateFromLocal = (0, localizeUtils_1.getLocalizedString)("plugins.function.getTemplateFromLocal");
//# sourceMappingURL=messages.js.map